/**
 * @generated SignedSource<<aeb6717fe7204129a1f4ee67ed302222>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MomentsMarkSeenMutation$variables = {
  at: any;
};
export type MomentsMarkSeenMutation$data = {
  readonly markMilestonesSeen: {
    readonly learner: {
      readonly id: string;
      readonly milestonesSeenAt: any | null | undefined;
    } | null | undefined;
  };
};
export type MomentsMarkSeenMutation = {
  response: MomentsMarkSeenMutation$data;
  variables: MomentsMarkSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "at"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "at",
        "variableName": "at"
      }
    ],
    "concreteType": "MarkMilestonesSeenPayload",
    "kind": "LinkedField",
    "name": "markMilestonesSeen",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "milestonesSeenAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MomentsMarkSeenMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "MomentsMarkSeenMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d310124971aa2c973523fc574c2c1381",
    "id": null,
    "metadata": {},
    "name": "MomentsMarkSeenMutation",
    "operationKind": "mutation",
    "text": "mutation MomentsMarkSeenMutation(\n  $at: DateTime!\n) {\n  markMilestonesSeen(at: $at) {\n    learner {\n      id\n      milestonesSeenAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c32cc460b1b49a419413ed1c08c09c01";

export default node;
